import userData from './user.vue'
import addressData from './address.vue'
import messageDialog from '../../../components/message-dialog.vue'
import TwoFaInterno from '../../auth/2fa-interno.vue';
import auth from '../../../services/auth'
import Account from '../../../services/account'
import { update } from 'lodash';


export default {
  data() {
    return {
      loading: undefined,
      show2fa: false
    }
  },

  methods: {
    start() {
      let vm = this;
      this.loading = vm.$refs.userComponent.$validator.validateAll().then(res => {
        return vm.$refs.addressComponent.$validator.validateAll().then(res2 => {
          auth.tokenGenerateResend(auth.currentUser.taxIdNumber, 'UPDATE_ACCOUNT').then(r => {
            vm.show2fa = true;
          }).catch(err => {
            messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
          });
        });
      });
    },
    save(){
      let vm = this;
      vm.show2fa = false;

      let userObject = vm.$refs.userComponent.user;

      delete userObject.accountAuthentication;
      //Comentado para o objeto do usuário não ser substituido por null quando o update acontecer ;)
          // delete userObject.company;
          // delete userObject.person;

      this.loading = Account.updateUser(userObject).then(res => {

        Account.updateAddress(vm.$refs.addressComponent._data.address).then(res => {

        messageDialog.show({ title: 'Sucesso', message: 'Seus dados foram salvos com sucesso.'});

        })

      })
      // this.loading = vm.$refs.userComponent.updateUser().then(res => {
      //   return vm.$refs.addressComponent.updateAddress().then(res => {
      //     messageDialog.show({ title: 'Sucesso', message: 'Seus dados foram salvos com sucesso.'});
      //   });
      // }).catch(err => {

      //   messageDialog.show({ title: 'Erro', message: err.data.status.message, headerClass: 'modal-danger' });
      // });


    }
  },
  components: {
    userData, addressData, TwoFaInterno
  }
}



// WEBPACK FOOTER //
// ./src/pages/account/profile/profile.js